module.exports = __webpack_public_path__ + "static/media/Sweden.4e078018.png";